import { GrippIcon, GrippIconVariant, tokens } from '@gripp/shared-ui';
import { useTranslation } from 'react-i18next';
import { Linking, Pressable, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { getOneLinkBaseUrl } from './oneLinkUtils';

/**
 * CTA shown at the top of the anonymous asset page prompting the visitor to
 * install the app. Links to the AppsFlyer OneLink platform URL (auto-detects
 * iOS/Android) — deliberately NOT the workspace invite link.
 */
export const GetGrippBanner = () => {
  const { t } = useTranslation();

  const openPlatformLink = () => {
    Linking.openURL(getOneLinkBaseUrl());
  };

  return (
    <View style={styles.banner}>
      <GrippIcon variant={GrippIconVariant.Light} width={64} height={64} />
      <View style={styles.textColumn}>
        <Text style={styles.cta}>{t('issue.anonymous.getGrippCta')}</Text>
        <Pressable
          onPress={openPlatformLink}
          accessibilityRole="link"
          accessibilityLabel={t('issue.anonymous.openAppStore')}
        >
          <Text style={styles.link}>{t('issue.anonymous.openAppStore')}</Text>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.md,
    backgroundColor: tokens.colors.slate[100],
    borderRadius: tokens.borderRadius.lg,
    minHeight: 112, // 64px content + vertical breathing room
    paddingHorizontal: tokens.spacing.lg,
  },
  textColumn: {
    flex: 1,
    gap: tokens.spacing.xs,
  },
  cta: {
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.brand.black,
  },
  link: {
    ...tokens.typography.body.small,
    lineHeight: 18,
    color: tokens.colors.brand.black,
    textDecorationLine: 'underline',
  },
});
